import { useState } from 'react'

import { DesignClient } from 'api/clients/DesignClient'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { AlmanacFile } from 'types'

export const useConfirmDeleteDesign = (file: AlmanacFile) => {
  const [isProcessing, setIsProcessing] = useState(false)

  const onConfirm = async () => {
    if (!file?.id) return

    setIsProcessing(true)
    const res = await DesignClient.destroy(file.id)

    if (res.type === 'error') {
      if (res.status === 403) {
        showToastMessage('You do not have permission to delete this file', 'error')
        return false
      }

      showToastMessage('We were unable to delete your file', 'error')
      return false
    }

    showToastMessage(`${file.title} was deleted`)

    return true
  }

  return { onConfirm, isProcessing }
}
